import { useEffect, useState } from "react";
import { DateRangesState } from "../../pages/SharedContents/SharedProps";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { filterValue } from "../../util/SearchandFIlters/searchAndFilter";
import moment from "moment";

const useDateFilter = (props: string[]) => {
  const initialDateFields = props;
  const initialDateConfig = initialDateFields.reduce((acc, key) => {
    acc[key] = { fromDate: null, toDate: null };
    return acc;
  }, {} as DateRangesState);
  const [selectedDates, setSelectedDates] =
    useState<DateRangesState>(initialDateConfig);

  const [valueWithOperator, setValueWithOperator] = useState<filterValue[]>([]);

  useEffect(() => {
    const keys = Object.keys(selectedDates);
    const ObjectItem: any = [];

    keys?.forEach((date) => {
      const { fromDate, toDate } = selectedDates[date];
      if (fromDate != null && toDate != null) {
        const fiilterParam = {
          fieldValue: date,
          operator: operatorConstants.between,
          value: [getTime(fromDate), getTime(toDate, true)],
        };
        ObjectItem.push(fiilterParam);
      }
    });
    setValueWithOperator(ObjectItem);
  }, [selectedDates]);

  const getTime = (dataValue: Date | null, isEndTime?: boolean) => {
    const utcDate = dataValue ? new Date(dataValue) : new Date();
    const hours = isEndTime ? 23 : 0;
    const minutes = isEndTime ? 59 : 0;
    utcDate.setHours(hours, minutes, minutes);
    const epochTime = new Date(utcDate.toUTCString()).getTime();
    return epochTime; // getTimeinUTC(utcDate, isEndTime);
  };

  /// if we need send the time zone as UTC to backend we can use this
  const getTimeinUTC = (localDate: Date, isEndTime?: boolean) => {
    const _UTCYear = localDate.getUTCFullYear();
    const _UTCMonth = localDate.getUTCMonth();
    const _UTCDate = localDate.getUTCDate();
    const hours = isEndTime ? 23 : 0;
    const minutes = isEndTime ? 59 : 0;
    const _utc = new Date(
      Date.UTC(_UTCYear, _UTCMonth, _UTCDate, hours, minutes)
    ).getTime();
    return _utc;
  };
  const onUpdateFiltedDate = (
    key: string,
    dateType: "fromDate" | "toDate",
    newValue: string
  ) => {
    setSelectedDates((prevRanges) => ({
      ...prevRanges,
      [key]: {
        ...prevRanges[key],
        [dateType]: newValue === '' ? null : newValue,
      },
    }));
  };

  const onResetDate = () => {
    setSelectedDates(initialDateConfig);
    setValueWithOperator([]);
  };

  return { onUpdateFiltedDate, valueWithOperator, selectedDates, onResetDate };
};

export default useDateFilter;
